import { Icon, IconSize, IconType } from "@dexibit/core";
import type { RegisteredSidebar } from "@dexibit/core";
import { faBars, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { faSidebar } from "@fortawesome/pro-regular-svg-icons";

import { HamburgerButton, MobileBarContainer, PanelSidebarButton } from "./styles";

interface MobileBarProps {
  isDrawerOpen: boolean;
  onToggleDrawer: () => void;
  leftSidebar: RegisteredSidebar | undefined;
  isSidebarCollapsed: boolean;
  onToggleSidebar: () => void;
}

export const MobileBar = ({
  isDrawerOpen,
  onToggleDrawer,
  leftSidebar,
  isSidebarCollapsed,
  onToggleSidebar,
}: MobileBarProps) => {
  return (
    <MobileBarContainer>
      <HamburgerButton
        onClick={onToggleDrawer}
        aria-label="Toggle navigation"
        aria-expanded={isDrawerOpen}
      >
        <Icon
          type={IconType.fa}
          icon={isDrawerOpen ? faXmark : faBars}
          size={IconSize.lg}
        />
      </HamburgerButton>
      {leftSidebar && (
        <PanelSidebarButton
          onClick={onToggleSidebar}
          aria-label={
            isSidebarCollapsed ? `Show ${leftSidebar.label}` : `Hide ${leftSidebar.label}`
          }
          aria-expanded={!isSidebarCollapsed}
        >
          <Icon type={IconType.fa} icon={faSidebar} size={IconSize.lg} />
          {leftSidebar.label}
        </PanelSidebarButton>
      )}
    </MobileBarContainer>
  );
};
